import  { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { getMedicoInt, ActualizaMedico } from "../../services/medico";
import { ErrorContext } from "../../utils/context/error";
import { getUsuarioFind } from "../../services/user";
import { useValidacionFormulario } from "../../hooks/validacion";

function MedicoModal({ show, AreaI, AreaFId, UsuarioI, Tag, handleshow, onGuardado }) {

  const [habilita, setHabilita] = useState(false);
  const [activa, setActiva]= useState(false);
    
  const [area, setArea] = useState([]);
  const [data, setData] = useState([]);
  const [datas, setDatas] = useState({AreaId:AreaI,
                                      UsuarioId:UsuarioI,
                                      NombreMed:'',
                                      Tag:Tag});

  const [Titulo, setTitulo] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();
  const {validarCampos, limpiarError, claseLabel, claseCampo,} = useValidacionFormulario(datas);                                     

  const camposMayusculas = ["NombreMed"];  
  const timeoutRef = useRef(null);
  const longitudAnteriorRef = useRef(0);

//------------- Boton Cancelar -----------------------------------------------------------------------------------------
const handleCancel = async () => 
  {
    handleshow(false);
  };
   
//------------- Boton Aceptar ------------------------------------------------------------------------------------------
const handleAceptar = async () => 
  {
    const esValido = validarCampos(["AreaId","UsuarioId"]);
    if (!esValido) return;

    setHabilita(true);
    setShowToast(false);
    const response = await ActualizaMedico(datas);
    if (response) 
      {
        if (response.status === 200) 
         {
            onGuardado(response.data.data); 
            handleshow(false);
         } 
         else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
      }
      else 
       {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
       } 
    setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
  const handlefilas=(item)=>
    {
     setDatas({
               ...datas,
                UsuarioId:item.UsuarioId, 
                NombreMed:item.NombreUsr,  
              } );

     setData([]);
    }  

//----------- Medico por Area e Id -------------------------------------------------------------------------------------
  const fillMedicoInt = async (AreaId, UsuarioId) => 
    {
      setShowToast(false);
      const response = await getMedicoInt(AreaId, UsuarioId);
        if (response) 
          {
            if (response.status === 200) 
              {
                setArea(response.data.area);
                setDatas({
                  ...datas,
                  UsuarioId: response.data.data.MedicoId, 
                  NombreMed:response.data.data.NombreUsr,  
                } );
            }
            else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
        else
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true); 
        }  
    };
//------------ Busca beneficiario --------------------------------------------------------------------------------------
  const handleUsuario = async (query)=>
    {
      const texto = query.trim();
      
      // Cancelar cualquier búsqueda pendiente 
      if (timeoutRef.current) 
        clearTimeout(timeoutRef.current);
      
     // Detectar si está borrando
     const estaBorrando = texto.length < longitudAnteriorRef.current;
     longitudAnteriorRef.current = texto.length;

     // Si está borrando, no buscar
     if (estaBorrando) 
     {
        setData([]);
        return;
     }

    // Solo buscar con 4 caracteres o más
    if (texto.length <= 3) {
        setData([]);
        return;
    }

    timeoutRef.current = setTimeout(() => {
        Procesar(texto.toUpperCase());
    }, 1000);
};    

//------------ procesa la busqueda -------------------------------------------------------------------------------------
  const Procesar= async (query)=>
    {
       setActiva(true);
       const response = await getUsuarioFind(query);
       if (response)
       {
          if (response.status === 200) 
            {
               setData(response.data.data);
               setActiva(false);
            } 
          else 
          {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
          }  
          setActiva(false);
       }
    }

//----------------------------------------------------------------------------------------------------------------------
const handleChange = (e) => 
  {
    const { name, value } = e.target;
    let nombrecamp = name;
    setDatas((prev) => ({
      ...prev,
      [name]:
        name === "CargoId"
          ? Number(value)
          : camposMayusculas.includes(name)
            ? value.toUpperCase()
            : value,
    }));
    if (name ==='NombreMed')
      nombrecamp ='UsuarioId'
    limpiarError(nombrecamp);
    setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
useEffect(() => 
  {
    if (show) 
     {
      // setAreaId(AreaI);
      // setUsuarioId(UsuarioI);
       fillMedicoInt(AreaI, UsuarioI);
       if (Tag !== 0) 
        {
          if (Tag === 1) setTitulo("Editar Medico (" + UsuarioI + ")");
          if (Tag === 2) setTitulo("Eliminar Medico (" + UsuarioI + ")");
        } 
       else 
        {
        //  setUsuarioId(0);
          setTitulo("Adicionar Medico al Area");
        }
     }
  }, [show]);
//----------------------------------------------------------------------------------------------------------------------
  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
          <div className="flex lg:w-[25rem]">
              <form noValidate className="flex flex-col w-full">
                  <div className="flex flex-row w-full h-full ">
                     <div className="w-full">
                         <label className={claseLabel("AreaId")}>Area</label>
                         <select id="area" name="AreaId" className={claseCampo("AreaId")} value={datas.AreaId || 0} onChange={handleChange} label="Area" disabled={Tag === 2 || Tag === 1}>
                             <option value="0" disabled>
                                 Seleccionar una Area...
                             </option>
                             {area.map((item) => {
                               return (
                                     <option key={item.AreaId} value={item.AreaId}>
                                       {item.NombreArea}
                                     </option>
                               );
                              })}
                         </select>
                         <div className="w-full mt-4 relative">
                            <label className={claseLabel("UsuarioId")}>Profesional</label>
                                <input type="text" name='NombreMed' className={claseCampo("UsuarioId")} value={datas.NombreMed || ""} placeholder="Buscar Usuarios..." 
                                     onKeyUp={(e) => handleUsuario(e.target.value.toUpperCase())}
                                     onChange={handleChange}
                                     autoComplete="off" 
                                     disabled={Tag === 2 || activa}/>
                                <div className={ data.length >0 ? "block" : "hidden"}>
                                    <table className="absolute z-10 w-full  bg-white border border-gray-300 rounded shadow-lg mt-1 overflow-hidden">
                                        <thead className="border border-stone-200 text-sm font-medium ">
                                          <tr>
                                            <th className="px-2.5 py-2 text-start font-medium">Documento</th>
                                            <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                                            <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                                          </tr>
                                        </thead>
                                        <tbody className="group text-sm text-stone-800">
                                          {data.map((item) => (
                                            <tr className="border-b border-stone-200 last:border-0" key={item.UsuarioId}  onClick={() => handlefilas(item)}>
                                                <td>{item.NumeroNit}</td>
                                                <td>{item.NombreUsr}</td>
                                                <td>{item.NombreCar}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                    </table>      
                                </div>
                         </div>
                      </div>   
                      
                  </div>
                  <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                      </div> 
              </form> 
          </div> 
          
    </Modal>          
    </>
  );
}
MedicoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  UsuarioI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  onGuardado: PropTypes.func.isRequired,
};

export default MedicoModal;
